import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserTokens } from '../../../../../store/user/user.selector.js';

// components
import HeaderBtn from '../header-btn/HeaderBtn';

// assets
import tokenIcon from '../../../../../assets/system/icons/pullvault-token.png';

export default function HeaderTokenPill({ navigateTo, tokens }) {
    const userTokens = useSelector(selectUserTokens);
    const displayTokens = tokens !== undefined ? tokens : userTokens;

    if (displayTokens === null || displayTokens === undefined) {
        return null;
    }

    return (
        <Link to={navigateTo} style={{ textDecoration: 'none', color: 'inherit' }}>
            <HeaderBtn val={displayTokens}>
                <img src={tokenIcon} alt='Pull Vault token icon' />
            </HeaderBtn>
        </Link>
    );
}